<template>
    <div>
        <div v-if="submit" style="display: flex;flex-direction: column;justify-content: center;align-items: center;"
            class="intro-box">
            <span style="color: #656587;
                                text-align: center;
                                font-family: Afacad;
                                font-size: 20px;
                                font-style: normal;
                                font-weight: 600;
                                line-height: normal;
                                ">已推到人才库</span>
        </div>
        <div v-if="!submit" class="job-list">
            <div class="job-item" v-for="(job, index) in jobs" :key="index">
                <!-- 复选框保留 -->
                <el-checkbox v-model="selectedJobs" :label="job.name"></el-checkbox>

                <!-- 点击区域：job-info 增加点击事件 -->
                <div class="job-info" @click="activeJobId = activeJobId === index ? null : index">
                    <div class="company-info">
                        <img :src="job.company.logo" :alt="job.company.name" class="company-logo">
                        <div class="company-name">{{ job.company.name }}</div>
                    </div>
                    <div class="job-meta">
                        <div class="job-category">{{ job.category }}</div>
                        <div class="job-scale">{{ job.scale }}</div>
                    </div>
                    <div class="job-details">
                        <div class="salary">{{ job.salary }}</div>
                        <div class="location">{{ job.location }}</div>
                        <div class="schedule">{{ job.schedule }}</div>
                        <div class="duration">{{ job.duration }}</div>
                    </div>
                </div>

                <!-- 详情区域：根据 activeJobId 显示当前职位的详情 -->
                <div v-if="activeJobId === index" class="intro-box">
                    <p class="team-intro">{{ job.detail.teamIntro }}</p>
                    <p class="job-responsibility">岗位职责：</p>
                    <ul class="responsibility-list">
                        <li v-for="(resp, i) in job.detail.responsibilities" :key="i">{{ resp }}</li>
                    </ul>
                </div>
            </div>


        </div>

        <div v-if="!submit" class="dialog-footer">
            <div class="select-all">
                <el-checkbox v-model="isAllSelected" @change="handleSelectAll">全选</el-checkbox>
            </div>
            <el-button type="primary" @click="submitSelection">提交</el-button>
        </div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            submit: false, // 是否提交
            selectedJobs: [], // 选中的职位
            isAllSelected: false, // 全选状态
            activeJobId: null, // 当前激活的职位索引（控制详情显示）
            showJobDialog: false,
            allscore: 0, // 总分
            position: '',
            jobs: [
                {
                    name: '市场风险量化分析实习生',
                    company: {
                        name: '中金财富',
                        logo: require('./assets/img/zhongjin.png'),
                    },
                    category: '金融/经济/投资/财会',
                    scale: '2000人以上',
                    salary: '100-150/天',
                    location: '深圳',
                    schedule: '4天/周',
                    duration: '3个月',
                    detail: {
                        teamIntro: '中金财富相关业务部门，专注于金融市场风险管控与量化分析工作，为客户提供专业的金融服务与风险保障。',
                        responsibilities: [
                            '市场风险量化分析，包括权益类市场风险计量、模型验证等',
                            '衍生品模型与计量，包括场外衍生品定价建模，衍生品对冲风险、对冲效率计量分析',
                            '市场利率走势跟踪与分析、债券市场风险分析计量',
                            '风险监测系统的搭建，包括核对系统底层数据，校对系统内部逻辑以及优化系统功能',
                            '负面舆情监控，整理信用主体相关的负面舆情，并生成舆情报告'
                        ],
                        requirements: [
                            '诚信正直、低调谦逊、艰苦奋斗，具备良好的道德品质',
                            '硕士及以上学历，数学、物理、统计、计算机、金融工程等相关专业',
                            '数理基础扎实，熟悉归因分析、方差分析、蒙特卡洛模拟等方法，具备一定编程能力，熟练使用Python、R等语言',
                            '学习能力强、逻辑性强、有责任心，踏实严谨',
                            '能够现场办公'
                        ]
                    }
                },
                {
                    name: '投资助理实习生',
                    company: {
                        name: '中金财富',
                        logo: require('./assets/img/zhongjin.png'),
                    },
                    category: '金融/经济/投资/财会',
                    scale: '2000人以上',
                    salary: '100/天',
                    location: '北京',
                    schedule: '4天/周',
                    duration: '6个月',
                    detail: {
                        teamIntro: '中金财富投资业务团队，负责投资交易支持、产品运营及投研辅助等工作，助力投资业务高效开展。',
                        responsibilities: [
                            '负责支持投资助理、投资交易、产品运营等相关工作',
                            '负责投顾业务投资建议书的撰写，全程跟进投资交易的执行情况',
                            '数据处理，如整理维护交易确认数据、各类净值、规模数据更新等',
                            '数据监控，如打新数据监控、CTA市场指标监控、量化指标监控',
                            '整理各账户持仓表、账户管理相关信息及销售材料更新'
                        ],
                        requirements: [
                            '诚信正直、低调谦逊、艰苦奋斗，具备良好的道德品质',
                            '实习长度能达到6个月，每周可出勤四天及以上，抗压能力强',
                            '本科或硕士在读，实习时间可保证者优先',
                            '有较好的数量分析、编程基础，需掌握Python或VBA等编程语言',
                            '国内外院校数理、金融相关专业，有券商、基金等机构投研实习经历优先'
                        ]
                    }
                },
                {
                    name: '战略规划实习生',
                    company: {
                        name: '京东',
                        logo: require('./assets/img/jd.png'),
                    },
                    category: '互联网/游戏/软件',
                    scale: '2000人以上',
                    salary: '200-300/天',
                    location: '北京',
                    schedule: '5天/周',
                    duration: '3个月',
                    detail: {
                        teamIntro: '京东战略规划团队，聚焦行业趋势研究与战略布局，支撑公司核心业务的可持续发展与创新突破。',
                        responsibilities: [
                            '根据京东战略规划，收集、分析宏观数据，跟进市场走势，提供行业趋势研究报告',
                            '研究行业趋势，解析相关政策，洞察细分市场规模，剖析产业链并输出研究报告',
                            '配合各业务单元开展行业和竞争分析，提出有关策略和建议',
                            '组织并完成专项研究项目，推动跨部门合作及资源整合',
                            '开展重大战略发展问题和关键课题研究'
                        ],
                        requirements: [
                            '统招本科及以上学历在校生，26届优先',
                            '热爱互联网，熟悉互联网主要发展方向和概念，对科技行业有思考和见解',
                            '熟悉实证研究的方法论，具备分析统计知识和研究能力',
                            '良好的口头及书面表达能力，组织协调能力强，具备商业意识',
                            '符合京东价值观：客户为先、创新、拼搏、担当、感恩、诚信'
                        ]
                    }
                },
                {
                    name: '数据分析实习生',
                    company: {
                        name: '滴滴',
                        logo: require('./assets/img/didi.png'),
                    },
                    category: '互联网/游戏/软件',
                    scale: '2000人以上',
                    salary: '200-300/天',
                    location: '上海',
                    schedule: '3天/周',
                    duration: '6个月',
                    detail: {
                        teamIntro: '滴滴策略分析团队，负责通过数据分析支撑业务决策与策略优化，提升出行服务的效率与用户体验。',
                        responsibilities: [
                            '基于业务需求进行数据处理，准确及时地完成常态数据报表开发和产出',
                            '协助策略分析团队进行专项数据分析需求和系统测试等支持工作'
                        ],
                        requirements: [
                            '本科及以上（非26年应届）学历，在校生，数学、统计学、金融工程等相关专业',
                            '喜欢数据分析，逻辑分析能力强，做事认真细致，有志从事数据分析岗位',
                            '数据处理能力优秀，熟练使用SQL、Python等语言',
                            '有消费信贷风险管理实习经验者优先',
                            '至少实习6个月，一周到岗3天及以上'
                        ]
                    }
                },
                {
                    name: '行业研究实习生',
                    company: {
                        name: '国金证券',
                        logo: require('./assets/img/guojin.png'),
                    },
                    category: '金融/经济/投资/财会',
                    scale: '2000人以上',
                    salary: '100-150/天',
                    location: '上海',
                    schedule: '3天/周',
                    duration: '3个月',
                    detail: {
                        teamIntro: '国金证券研究部门，专注于金融地产、传媒互联网等领域的行业研究，为投资决策提供专业支持。',
                        responsibilities: [
                            '协助部门进行行业研究，主要领域为金融地产/传媒互联网方向',
                            '进行专题行业研究的报告撰写',
                            '跟进市场及行业数据的统计与分析',
                            '完成研究员交办的其他工作'
                        ],
                        requirements: [
                            '2025年及以后毕业的在校生，本科及以上学历，大四保研优先',
                            '学习能力强，具备良好的自我驱动能力，有地产/固收相关背景优先',
                            '对金融、地产、传媒互联网等行业有深度研究经验者优先，有行研实习经历优先',
                            '一周实习5天（现场实习天数不少于3天），至少3个月，能长期实习优先'
                        ]
                    }
                },
                {
                    name: '行政助理实习生',
                    company: {
                        name: '德邦证券',
                        logo: require('./assets/img/dbzq.png'),
                    },
                    category: '金融/经济/投资/财会',
                    scale: '2000人以上',
                    salary: '80-120/天',
                    location: '上海',
                    schedule: '5天/周',
                    duration: '3个月',
                    detail: {
                        teamIntro: '德邦证券中后台支持团队，负责部门行政事务与业务辅助，保障部门日常运营的高效有序。',
                        responsibilities: [
                            '根据公司采购制度要求，协助推进部门请采购事项',
                            '协助汇总和统计分析部门相关各类业务数据、费用，负责部门报销等流程操作',
                            '协助部门常规行政事务的处理及执行，包括办公设备维护、文档复印等',
                            '协助部门中台进行对外宣传文案的编辑、剪辑等基础工作'
                        ],
                        requirements: [
                            '本科以上学历，统计学、行政管理相关专业背景优先，有中后台助理实习经历者优先',
                            '热情、开朗，善于与人交流，有服务意识',
                            '具有较好的ppt、excel等办公软件的使用技能',
                            '能在上海线下实习2个月以上，能够接受每周4-5天实习'
                        ]
                    }
                },
                {
                    name: '投资银行实习生',
                    company: {
                        name: '华创证券',
                        logo: require('./assets/img/hczq.png'),
                    },
                    category: '金融/经济/投资/财会',
                    scale: '2000人以上',
                    salary: '薪资面议',
                    location: '上海',
                    schedule: '5天/周',
                    duration: '3个月',
                    detail: {
                        teamIntro: '华创证券投资银行团队，专注于债券融资等投行业务，为企业提供专业的金融服务与解决方案。',
                        responsibilities: [
                            '协助团队完成公司债券融资项目等业务相关的辅助支持工作，包括起草文件、整理资料等',
                            '收集、整理和分析行业、企业和市场信息，为决策提供有力支持',
                            '参与项目方案设计、报告撰写、尽职调查、材料申报和底稿归档等工作',
                            '分析一级市场发行数据整理分析及销售方面的辅助工作'
                        ],
                        requirements: [
                            '在读硕士学位，优先考虑经济、金融、经管等相关专业背景',
                            '具备一定的投资银行业务了解，有固收相关实习经验的候选人优先',
                            '具备清晰的逻辑思维能力、财务分析能力以及行业研究能力',
                            '具备良好的沟通、团队协作和组织协调能力，实习期至少3个月'
                        ]
                    }
                },
                {
                    name: '行业研究实习生',
                    company: {
                        name: '百度',
                        logo: require('./assets/img/bd.png'),
                    },
                    category: '互联网/游戏/软件',
                    scale: '2000人以上',
                    salary: '200-250/天',
                    location: '北京',
                    schedule: '5天/周',
                    duration: '3个月',
                    detail: {
                        teamIntro: '百度搜索与智能体业务团队，负责行业研究与竞对分析，支撑业务战略的制定与优化。',
                        responsibilities: [
                            '具备互联网行业理解和敏锐度，协助进行行业整体市场环境的分析',
                            '协助进行搜索和智能体等细分业务领域发展、竞品扫描等工作',
                            '基于整体业务战略发展需要，协助开展市场、竞对、用户等相关的专项研究',
                            '支持业务侧的数据分析及材料整理工作'
                        ],
                        requirements: [
                            '有咨询公司、互联网行业行业研究等实习经验优先',
                            '对互联网有强烈兴趣，对搜索、智能体等产品具备一定的洞察力与敏感度',
                            '工作积极主动，具备较好的逻辑思维能力、沟通能力、表达能力和团队合作意识',
                            '快速学习能力强'
                        ]
                    }
                },
                {
                    name: '数据分析实习生',
                    company: {
                        name: '美团',
                        logo: require('./assets/img/meituan.png'),
                    },
                    category: '互联网/游戏/软件',
                    scale: '2000人以上',
                    salary: '200-300/天',
                    location: '北京',
                    schedule: '5天/周',
                    duration: '3个月',
                    detail: {
                        teamIntro: '美团业务分析团队，通过数据分析驱动业务优化，提升平台运营效率与用户体验。',
                        responsibilities: [
                            '基于业务，完善业务监控体系和分析体系，包括KPI指标体系、搭建分析框架',
                            '深入业务，研究分析相关行业的标杆，诊断业务问题并提出策略建议',
                            '与业务产品团队、运营团队密切配合，提供相关分析支持和决策支持'
                        ],
                        requirements: [
                            '具备出色的逻辑思维能力和快速的学习能力，乐于思考',
                            '有互联网行业或线上营销行业相关数据分析、经营分析实习经验',
                            '熟练使用sql进行数据查询，使用常用数据工具进行数据分析，数据模型探索',
                            '具有良好的逻辑分析能力、沟通能力、团队合作意识',
                            '业务敏感度强，自驱力强，具有良好的商业敏感度和数据分析技能'
                        ]
                    }
                },
                {
                    name: '量化模型实习生',
                    company: {
                        name: '开源证券',
                        logo: require('./assets/img/kyzq.png'),
                    },
                    category: '金融/经济/投资/财会',
                    scale: '2000人以上',
                    salary: '70-100/天',
                    location: '上海',
                    schedule: '3天/周',
                    duration: '3个月',
                    detail: {
                        teamIntro: '开源证券量化研究团队，专注于金融数据建模与交易策略研发，探索智能化投资方法。',
                        responsibilities: [
                            '协助针对历史数据开展特征工程，设计并实现特征',
                            '协助完成预测模型的训练及调优',
                            '在领导指导下，协助设计并实现交易模型，并完成历史回测',
                            '完成上级交办的其他工作'
                        ],
                        requirements: [
                            '本科及以上学历在读，金融工程、数学、计算机相关专业优先',
                            '熟悉主流AI/ML模型（树模型、GRU、LSTM等），熟练使用其中一种',
                            '熟练使用Python，对数据敏感，擅长运用技术分析、量化模型分析工具',
                            '通过证券从业资格、CFA、FRM考试者优先'
                        ]
                    }
                }
            ],
        }
    }
}
</script>

<style scoped>


.job-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.job-dialog-title {
    margin: 0;
    font-size: 18px;
    color: #333;
}

.close-btn {
    font-size: 20px;
    cursor: pointer;
    color: #999;
}

.job-list {
    padding: 20px;
    overflow: auto;
}

.job-item {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    padding: 15px 0;
    border-bottom: 1px dashed #eee;
}

.job-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    flex-grow: 1;
    cursor: pointer;
}

.company-info {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.company-logo {
    background-color: #fff;
    width: 40px;
    height: 30px;
    margin-right: 10px;

}

.company-name {
    font-size: 14px;
    font-weight: bold;
    color: #333;
}

.job-meta {
    font-size: 12px;
    color: #666;
    margin-bottom: 5px;
}

.job-details {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
    color: #666;
}

.salary,
.location,
.schedule,
.duration {
    margin-left: 15px;
}

.select-all {
    display: flex;
    align-items: center;
}

.dialog-footer {
    position: sticky;
    bottom: 0;
    background-color: rgba(255, 255, 255, .72);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 1;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* 垂直居中 */
    padding: 12px 20px;
    max-height: 100px;
    min-height: 70px;
}
</style>